module.exports = __webpack_public_path__ + "static/apple-watch-9d7342c764e7d2c40657f6e5fa55e0cd.png";